


function MatchHeight() {
     jQuery("body .card-information h3.card__heading a.card-title").matchHeight();  
  
     jQuery(".collections-wrapper .collection-title").matchHeight();
     jQuery(".footer-block__column .footer-block__heading").matchHeight();
  

}

$(document).ready(function(){
  MatchHeight();
});

$(window).on('load', function(){
  function MatchHeight() {
  } 
  window.setTimeout(MatchHeight(), 5000); 
});


document.addEventListener('DOMContentLoaded', () => {
  const viewChartBtn = document.querySelector('.view-chart-btn');
  const chartHeading = document.getElementById('chartHeading');

  if (viewChartBtn && chartHeading) {
    viewChartBtn.addEventListener('click', () => {
      chartHeading.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
});
